import { render, staticRenderFns } from "./user_head.vue?vue&type=template&id=18dcf8bc&scoped=true"
import script from "./user_head.vue?vue&type=script&lang=js"
export * from "./user_head.vue?vue&type=script&lang=js"
import style0 from "./user_head.vue?vue&type=style&index=0&id=18dcf8bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dcf8bc",
  null
  
)

export default component.exports